import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setListAllUsers } from "../../../../redux/slice/patientsSlice";
import { useEffect } from "react";
import TableAllUsers from "./TableAllUsers/TableAllUsers";
import Loading from "../../../../components/Loading/Loading";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { getAllUsers } from "../../../../services/rest/users/userProviderService";
import ButtonHireMembership from "../../../../components/ButtonHireMembership/ButtonHireMembreship";
import SearchInputEmail from "../../../../components/Dashboard/SearchInput/SearchInputEmail";

function createData(
  _id,
  firstName,
  lastName,
  email,
  phoneNumber,
  membership,
  rol
) {
  return {
    _id,
    firstName,
    lastName,
    email,
    phoneNumber,
    membership,
    rol,
  };
}

const AddPatient = () => {
  const [loading, setLoading] = useState(true);
  const { listAllUsers } = useSelector((state) => state.patientsReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { rol } = useSelector((state) => state.userReducer);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getListUsers = async () => {
      try {
        setLoading(true);
        const formatRows = [];
        //Aqui se hace la peticion a la api de lista de usuarios
        const responseListUsers = await getAllUsers();
        responseListUsers.forEach((patient) => {
          if (patient?._id) {
            formatRows.push(
              createData(
                patient?._id ?? 0,
                patient?.firstName ?? "---",
                patient?.lastName ?? "---",
                patient?.email ?? "---",
                patient?.phoneNumber ?? "---",
                patient?.membership ?? "---",
                patient?.rol ?? "---"
              )
            );
          }
        });
        //Validamos status de la membresía
        // console.log("Estado de la membresia", membershipStatus);

        if (membershipStatus !== "active") {
          dispatch(setListAllUsers({ listAllUsers: [] }));
          toast.error("Su membresía no esta activa.", 50000);
          setLoading(false);
          return;
        }
        dispatch(setListAllUsers({ listAllUsers: formatRows }));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(
          "No pudimos obtener los usuarios.  \n Intentelo más tarde."
        );
      }
    };
    getListUsers();
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Loading loading={loading} />
      <Box sx={{ display: "flex", gap: 2 }}>
        <PersonAddAltIcon style={{ fontSize: 32 }} />
        <Typography variant="h5">
          {rol === "Coach" ? "Agregar Corredor" : "Agregar paciente"}
        </Typography>
        {membershipStatus !== "active" && <ButtonHireMembership />}
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SearchInputEmail
          searchEmail={searchEmail}
          setSearchEmail={setSearchEmail}
          setFilteredUsers={setFilteredUsers}
          setLoading={setLoading}
          filteredUsers={filteredUsers}
          listAllUsers={listAllUsers}
        />
      </Box>
      <Box>
        <TableAllUsers
          setLoading={setLoading}
          type="addUser"
          rows={
            filteredUsers && filteredUsers.length > 0
              ? filteredUsers
              : listAllUsers
          }
        />
      </Box>
    </Box>
  );
};

export default AddPatient;
